import { DirectDealsList } from '@openx/components-direct-deals/lib/DirectDealsList/DirectDealsList';
import { RequestDirectDealModalProvider } from '@openx/components-direct-deals/lib/utils/context/RequestDirectDealModalContext';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';

export const DirectDealsListPage = () => {
  const { t } = useTranslation();

  return (
    <PageHeader titlePrefix="OpenXSelect" title={t('Direct Deals')}>
      <RequestDirectDealModalProvider>
        <DirectDealsList />
      </RequestDirectDealModalProvider>
    </PageHeader>
  );
};
